export function SortTableAsc(collections: any){
    if (collections?.length > 0 && typeof collections[0] === 'number') {
        return collections.sort((n1: number, n2: number) => n1 - n2)
      } else {
        return collections?.sort((s1: string, s2: string) => s1.localeCompare(s2));
      }
}

export function sortByDate(a: any | undefined, b: any | undefined) {
  if (a === undefined && b === undefined) {
    return 0;
  } else if (a === undefined) {
    return 1;
  } else if (b === undefined) {
    return -1;
  }
    const dateA = new Date(a);
    const dateB = new Date(b);
    return dateA.getTime() - dateB.getTime();
}